<template>
    <div>
        <gofix-card classContent="mt-4 mb-0">
            <b-row align-v="center">
                <b-col md="4">
                    <gofix-form-dropdown
                            label="Client contract"
                            v-model="item.contract"
                            :options="contracts"
                            required
                            vLabel="contract_name">
                    </gofix-form-dropdown>
                </b-col>
                <b-col md="4">
                    <gofix-form-supplier
                            label="Supplier"
                            required
                            :contract-id="item.client_contract_id"
                            v-model="item.supplier">
                    </gofix-form-supplier>
                </b-col>
                <b-col md="4">
                    <b-row align-v="center">
                        <b-col md="6">
                            <gofix-text-field label="Create By:" class="mb-26" oneline>
                                {{item.created_by_user ? item.created_by_user.name : $route.params.id == 0 ? UserLogin.name : "N/A"}}
                            </gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Create On:" class="mb-26" oneline>
                                {{item.created_at | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="4">
                    <gofix-form-input-date
                            v-model="item.ld_date"
                            label="LD Date">
                    </gofix-form-input-date>
                </b-col>
                 <b-col md="4">
                    <gofix-form-input-date
                            v-model="item.issue_date_budget"
                            label="Date Issued Budget">
                    </gofix-form-input-date>
                </b-col>
            </b-row>
        </gofix-card>
        <gofix-card classContent="mt-4 mb-0">
            <b-row class="mb-3">
                <b-col md="4">
                    <gofix-form-input-number
                            desc="$(0.00)"
                            allowNegative
                            label="Total Amount"
                            v-model="item.total"
                            @change="changeAmount"
                            prefix="$("
                            suffix=")"></gofix-form-input-number>
                </b-col>
                <b-col md="12">
                    <gofix-form-input-textarea label="Reason" class="caseDescTextArea" v-model="item.reasons">
                    </gofix-form-input-textarea>
                </b-col>
                <b-col md="4">
                    <gofix-form-dropdown
                            label="GL Code"
                            :options="glCodes"
                            v-model="item.gl_code"
                            append-to-body
                            desc="NOTE: This is only for recoverable LD."
                            vLabel="name"
                            :filterable="true">
                        <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                            <div class="flex">
                                <div class="">
                                    <span>{{option.gl_code + " " + option.name }}</span>
                                </div>
                            </div>
                        </template>
                        <template slot="gofixInput:dropdown:option" slot-scope="option">
                            {{ option.gl_code + " " + option.name }}
                        </template>
                    </gofix-form-dropdown>
                </b-col>
                <b-col md="4">
                    <gofix-text-field class="mt-4" label="GL Description:" oneline>
                        {{item.gl_code ? item.gl_code.name : "--"}}
                    </gofix-text-field>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <gofix-form-dropdown
                            label="FM Code"
                            :options="fmCodes"
                            @search="searchFMCode"
                            append-to-body
                            v-model="item.fm_code"
                            :getOptionLabel="getOptionLabel"
                            :filterable="false">
                        <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                            <div class="flex">
                                <div class="">
                                    <!--<span>{{ option.chart_of_account ? option.fm_code + " - " + option.gl_code + " - " + option.chart_of_account.name : option.fm_code + " - " + option.gl_code}}</span>-->
                                    <span>{{ option.fm_code + " - " + option.description}}</span>
                                </div>
                            </div>
                        </template>
                        <template #gofixInput:dropdown:option="option">
                            <!--{{ option.chart_of_account ? option.fm_code + " - " + option.gl_code + " - " + option.chart_of_account.name : option.fm_code + " - " + option.gl_code }}-->
                            {{ option.fm_code + " - " + option.description }}
                        </template>
                    </gofix-form-dropdown>
                </b-col>
                <b-col md="8">
                    <gofix-text-field class="mt-4" label="FM Description:" oneline>
                        {{item.fm_code ? item.fm_code.description : "--"}}
                    </gofix-text-field>
                </b-col>
            </b-row>
        </gofix-card>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    export default {
        name: 'liquidated-damages-info',
        components:{},
        data() {
            return {
                contracts:[],
                glCodes:[],
                fmCodes: [],
                timer: {
                    fm_code: null
                }
            }
        },
        watch: {
            "item.supplier":function(val){
                this.item.supplier_id = val ? val.id : null;
            },
            "item.gl_code" : function(val){
                this.item.gl_code_id = val ? val.id : null;
            },
            "item.fm_code" : function(val){
                this.item.fm_code_id = val ? val.id : null;
            },
            "item.contract": function(val){
                this.item.client_contract_id = val && val.id ? val.id : null;
                this.getFMCode();
            },
            contractSelector: function(val, old){
                if((old && val && old.id != val.id) || (!old && val)) {
                    this.item.contract = val;
                }
            }
        },
        computed: {
            ...mapGetters({
                UserLogin: "AuthController/user",
                contractSelector: 'ContractController/ClientContractID',
                item: "LiquidatedDamagesController/item",
            }),
        },
        async created() {
            if(this.$route.params.id == 0 && !this.item.client_contract_id){
                // this.item.client_contract_id = this.contractSelector ? this.contractSelector.id : null;
                this.item.contract = this.contractSelector ? this.contractSelector : null;
            }
            this.getContracts();
            this.getCOA();
        },
        methods: {
            getContracts(filter = null, limit = -1) {
                this.$store.dispatch(`ContractController/getListClientContractsSearch`, [1, filter, limit])
                    .then(response => {
                        this.contracts = response.data;
                    })
            },
            changeAmount(){
                if(this.item.total){
                    let amount = this.$accounting.unformat(this.item.total);
                    if(amount > 0){
                        this.item.total = this.$accounting.formatMoney((0 - amount), { format: {
                                pos : "%s %v",
                                neg : "%s (%v)",
                                zero: "%s %v"
                            } });
                    }
                }
            },
            getCOA() {
                this.$store.dispatch("FmCodeController/getCOA",{limit: -1}).then(response => {
                    this.glCodes = response.items;
                })
                    .catch(err => {
                        this.glCodes = [];
                    });
            },
            getOptionLabel(option){
                let label = option.gl_code + " " + option.name;
                return label;
            },
            getFMCode(filter = null, limit = 100) {
                let contractID = this.item.client_contract_id
                this.$store.dispatch("FmCodeController/getFmCodeItems", { limit: limit, page: 1, filter: filter, contract_id : contractID })
                .then(response => {
                    this.fmCodes = response.items;
                })
            },
            searchFMCode(search, loading) {
                this.fmCodes = []
                loading(true);
                if (this.timer.fm_code) {
                    clearTimeout(this.timer.fm_code);
                    this.timer.fm_code = null;
                }
                this.timer.fm_code = setTimeout(async () => {
                    try {
                        await this.getFMCode({fm_code: search});
                        await loading(false);
                    }
                    catch(err) {
                        loading(false);
                    }
                }, 500);
            },
        }
    }
</script>
